import {useWindowSize} from "../../hooks/useWindowSize";

const Footer = () => {
   const size = useWindowSize()

    return (
        <div className={`bg-[#CBD6E5] min-h-[42px] mt-auto ml-[-20px]`}
             style={{minWidth: (size.width)}}
        >
        </div>
    )
}

export default Footer